<template>
  <v-col cols="12" sm="6" md="5" lg="4">
    <v-card
        flat
        class="rounded-lg"
    >
      <v-card-item style="background: linear-gradient(241.48deg, #07a01d -24.3%, #d5cb6c 172.89%);">
        <div class="d-flex align-center my-5">
          <img class="rounded-image" src="/icon-investment-standart.png" alt="standart">
          <v-card-title class="text-white ml-5">
            {{ this.contractNumber }}
          </v-card-title>
        </div>
        <p class="text-white">{{ $t('investments.card.amountOfInvestment') }}</p>
        <v-card-title class="text-white font-weight-bold">
          {{ $formatNumber(this.amountByDeal) }} {{ this.currency }}
        </v-card-title>
      </v-card-item>

      <v-card-text class="mt-6">
        <div class="my-2">
          <span>{{ $t('investments.card.investmentPeriod') }}: </span>
          <span class="text-no-wrap text-grey-darken-2">
            {{ $formatDate(this.dateOfContract) }} — {{ $formatDate(this.dateEnd) }}
          </span>
        </div>

        <div class="my-2">
          <span>{{ $t('investments.card.interestRate') }}: </span>
          <span class="text-grey-darken-2">{{ this.interestRate }}%</span>
        </div>

        <div class="my-2">
          <span>{{ $t('investments.card.paymentFrequency') }}: </span>
          <span class="text-grey-darken-2">{{ $t(`investments.card.frequencies.${repaymentFrequency}`) }}</span>
        </div>

        <div class="my-2">
          <span>{{ $t('investments.card.nextPayment') }}: </span>
          <span class="text-grey-darken-2">{{ $formatNumber(this.amountPeriodic) }} {{ this.currency }}</span>
        </div>

        <div class="my-2">
          <span>{{ $t('investments.card.nextPaymentDate') }}: </span>
          <span class="text-grey-darken-2">{{ $formatDate(this.dateNextPayout) }}</span>
        </div>
      </v-card-text>

      <!-- <v-row class="pb-9">
        <v-col class="d-flex justify-end">
          <PrimaryButton class="ml-3" :button-text="$t('investments.card.actions.partialWithdrawal')" />
        </v-col>

        <v-col class="d-flex justify-start">
          <SecondaryButton class="mr-3" :button-text="$t('investments.card.actions.improveConditions')" />
        </v-col>
      </v-row> -->
    </v-card>
  </v-col>
</template>

<script>
// import SecondaryButton from "@/components/SecondaryButton.vue";
// import PrimaryButton from "@/components/PrimaryButton.vue";

export default {
  components: {
    // PrimaryButton,
    // SecondaryButton
  }
  ,
  props: [
    'guid',
    'contractNumber',
    'currency',
    'repaymentFrequency',
    'dateOfContract',
    'dateEnd',
    'interestRate',
    'dateNextPayout',
    'amountByDeal',
    'amountPeriodic',
    "isConfirmed",
    "isCreatedByAPI"
  ],
  data() {
    return {
      translations: {
        month: this.$t('investments.card.frequencies.month'),
        quarter: this.$t('investments.card.frequencies.quarter'),
        half_year: this.$t('investments.card.frequencies.half_year'),
        year: this.$t('investments.card.frequencies.year'),
      }
    }
  }
}
</script>

<style scoped>
.rounded-image {
  border-radius: 50%;
  width: 60px;
  height: 60px;
}
</style>
